/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "SqShippingQuote": {
                "fields": {
                  "verb": {
                    "type": "squareup.solidshop.model.SqShippingQuote.ShippingVerb",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timeUnit": {
                    "type": "squareup.solidshop.model.SqShippingQuote.TimeUnit",
                    "id": 2,
                    "rule": "optional"
                  },
                  "min": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "max": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "isDefault": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "priority": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ShippingVerb": {
                    "values": {
                      "SHIP": 1,
                      "ARRIVE": 2
                    }
                  },
                  "TimeUnit": {
                    "values": {
                      "HOURS": 1,
                      "BUSINESS_DAYS": 2,
                      "DAYS": 3,
                      "WEEKS": 4,
                      "MONTHS": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.SqShippingQuote && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.SqShippingQuote?.nested?.ShippingVerb && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.SqShippingQuote?.nested?.TimeUnit) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE SqShippingQuote @ squareup/solidshop/model/sq_shipping_quote.proto at 8:1
 */
export const SqShippingQuote = $root.lookupType('squareup.solidshop.model.SqShippingQuote');
fixType(SqShippingQuote);
Builder.createAndAttachToType(SqShippingQuote);
/**
 * SOURCE ShippingVerb @ squareup/solidshop/model/sq_shipping_quote.proto at 9:5
 */
SqShippingQuote.ShippingVerb = $root.lookupEnum('squareup.solidshop.model.SqShippingQuote.ShippingVerb').values;
/**
 * SOURCE TimeUnit @ squareup/solidshop/model/sq_shipping_quote.proto at 14:5
 */
SqShippingQuote.TimeUnit = $root.lookupEnum('squareup.solidshop.model.SqShippingQuote.TimeUnit').values;
